import { Dialog, DialogTitle, DialogActions, DialogContent, Button, Grid, CircularProgress } from '@material-ui/core';
import { Formik, Form, Field } from 'formik';
import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useObservable, useCallbackObservable } from 'react-use-observable';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import whitelistService from 'v2/services/whitelist';

import type { IWhiteList } from 'v2/interfaces/whitelist';

import CreateAndEditSchema from './validations';

import type { FormikProps } from 'formik';

const CreateAndEdit = () => {
  const [open] = useObservable(() => whitelistService.getCreateAndEditDialog(), []);
  const [currentWhiteList] = useObservable(() => whitelistService.getCurrentWhiteList(), []);
  const [onSubmit] = useCallbackObservable((values: IWhiteList, { setSubmitting, resetForm }: FormikProps<IWhiteList>) => {
    return whitelistService.saveOrUpdate(values).pipe(
      tap(() => {
        setSubmitting(false);
        resetForm({ values });
        whitelistService.setCreateAndEditDialog(false);
        if (values?.id) return toast.success('WhiteList alterado com sucesso.');
        return toast.success('WhiteList criado com sucesso.');
      }),
      catchError((err) => {
        const message = typeof err === 'string' ? err : 'Valide os campos obrigatórios';
        setSubmitting(false);
        toast.error(message);
        return of(true);
      })
    );
  }, []);

  const closeDialog = useCallback(() => {
    whitelistService.setCreateAndEditDialog(false);
  }, []);

  return (
    <Dialog open={open} disableRestoreFocus>
      <Formik initialValues={currentWhiteList} validationSchema={CreateAndEditSchema} onSubmit={onSubmit}>
        {({ values, isValid, isSubmitting }) => (
          <Form id='whitelist-form'>
            <DialogTitle>{values?.id ? 'Edite o cliente' : 'Adicione um novo cliente'}</DialogTitle>
            <DialogContent>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Field
                    id={'customer_name'}
                    name={'customer_name'}
                    component={TextFormField}
                    fullWidth
                    label={'Nome'}
                    placeholder={'Insira o nome'}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    id={'customer_email'}
                    name={'customer_email'}
                    component={TextFormField}
                    fullWidth
                    label={'E-mail'}
                    placeholder={'Insira o e-mail'}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    id={'customer_document'}
                    name={'customer_document'}
                    component={TextFormField}
                    fullWidth
                    label={'CPF/CNPJ'}
                    placeholder={'Insira o documento'}
                    mask={'document'}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={closeDialog}>Fechar</Button>
              <Button type='submit' color='secondary' variant='contained' disabled={!isValid || isSubmitting}>
                Salvar
                {isSubmitting && <CircularProgress size={10} style={{ color: '#192542', marginLeft: 10 }} />}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default CreateAndEdit;
